import React, { useMemo } from "react";
import { Alert } from "../../components/Alert";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { useWindowSize } from "../../hooks/useWindowSize";

export interface AdminPageProps {
    title: string;
    children: React.ReactNode;
    icon?: string;
    header?: React.ReactNode;
    error?: string;
    buttons?: AdminPageButton|AdminPageButton[]
}

export interface AdminPageButton {
    title: string;
    onClick: () => void;
    icon?: string;
}

export const AdminPage = ({title, children, icon, header, buttons, error}: AdminPageProps) => {
    const { innerWidth } = useWindowSize();
    const mobile = useMemo(() => innerWidth < 1000, [innerWidth]);
    

    return (
        <div className="d-flex flex-column w-100 h-100 align-items-center overflow-hidden">
            <div className={`d-flex flex-column w-100 h-100 my-${mobile ? 2 : 5} overflow-hidden`} style={{maxWidth: mobile ? '95%' : '85%'}}>
                <div className="d-flex flex-row w-100 align-items-center">
                    { icon && <MDBIcon icon={icon} size="xl" className="me-1"/> }
                    <h3 className="fw-bold flex-fill m-0">{title}</h3>
                    {header}
                    {buttons && (Array.isArray(buttons) ? buttons : [buttons]).map(btn => (
                        <MDBBtn key={btn.title} color="link" onClick={btn.onClick}>
                            <MDBIcon icon={btn.icon} color="primary" className="me-1"/>
                            {btn.title}
                        </MDBBtn>
                    ))}
                </div>
                
                <div className="d-flex flex-column w-100 h-100 mt-3 overflow-auto">
                    <Alert type="danger" className="mb-2" message={!error ? null : (
                        <div className="d-flex flex-row align-items-center">
                            <MDBIcon icon="exclamation-triangle" color="danger" className="me-1"/>
                            {error}
                        </div>
                    )}/>
                    {children}
                </div>
            </div>
            
        </div>
    )
}